import { createFileRoute } from '@tanstack/react-router';
import { SupplierOverviewPage } from '@/features/purchasing/SupplierOverview';
import { SupplierProfilePage } from '@/features/purchasing/SupplierProfile';
export const Route = createFileRoute('/_dashboard/dashboard/purchasing/suppliers/$supplierId')({
  component: Page,
});
function Page() {
  const { supplierId } = Route.useParams();
  // "new" is the add form; a real id opens the supplier's overview.
  return supplierId === 'new' ? (
    <SupplierProfilePage supplierId={supplierId} />
  ) : (
    <SupplierOverviewPage key={supplierId} supplierId={supplierId} />
  );
}
